import { coreClient } from '@/api/coreclient'
import type { FavoriteEntry, FavoriteMutationBody } from 'common'

export default {
  async list() {
    const client = await coreClient()
    return client.favorites
      .getFavorites()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as FavoriteEntry[]
      })
  },
  async add(payload: FavoriteMutationBody) {
    const client = await coreClient()
    return client.favorites
      .addFavorites(payload)
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async remove(payload: FavoriteMutationBody) {
    const client = await coreClient()
    return client.favorites
      .removeFavorites(payload)
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
